import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-payments-cookie',
  imports: [RouterLink],
  templateUrl: './payments-cookie.component.html',
  styleUrl: './payments-cookie.component.scss',
})
export class PaymentsCookieComponent {}
